// extracted by mini-css-extract-plugin
export default {"container":"MyDisciplines_container__s3QOA","disciplinesTable":"MyDisciplines_disciplinesTable__jv9RM"};